export enum QuestionnaireStatus {
	NotSelected = 0,
	NotApplicable = 1,
	Checked = 2,
	NotChecked = 3,
}
